import { apiService } from './api';
import {
  AuditLogQuery,
  AuditLogResponse,
  EntityAuditTrailResponse,
  UserActivityResponse,
  ActivityStatsResponse,
} from '../types/audit';

export const auditService = {
  /**
   * Get audit logs with filtering and pagination
   */
  async getLogs(query: AuditLogQuery = {}): Promise<AuditLogResponse> {
    const params = new URLSearchParams();
    
    if (query.userId) params.append('userId', query.userId);
    if (query.action) params.append('action', query.action);
    if (query.entityType) params.append('entityType', query.entityType);
    if (query.entityId) params.append('entityId', query.entityId);
    if (query.startDate) params.append('startDate', query.startDate);
    if (query.endDate) params.append('endDate', query.endDate);
    if (query.page) params.append('page', query.page.toString());
    if (query.limit) params.append('limit', query.limit.toString());

    const response = await apiService.get(`/api/audit/logs?${params.toString()}`);
    return response.data;
  },

  /**
   * Get audit trail for a specific entity
   */
  async getEntityAuditTrail(entityType: string, entityId: string): Promise<EntityAuditTrailResponse> {
    const response = await apiService.get(`/api/audit/entity/${entityType}/${entityId}`);
    return response.data;
  },

  /**
   * Get user activity
   */
  async getUserActivity(userId: string, days: number = 30): Promise<UserActivityResponse> {
    const response = await apiService.get(`/api/audit/user/${userId}/activity?days=${days}`);
    return response.data;
  },

  /**
   * Get current user's activity
   */
  async getMyActivity(days: number = 30): Promise<UserActivityResponse> {
    const response = await apiService.get(`/api/audit/my-activity?days=${days}`);
    return response.data;
  },

  /**
   * Get system activity statistics
   */
  async getActivityStats(days: number = 7): Promise<ActivityStatsResponse> {
    const response = await apiService.get(`/api/audit/stats?days=${days}`);
    return response.data;
  },

  /**
   * Export audit logs in specified format
   */
  async exportLogs(query: AuditLogQuery = {}, format: 'csv' | 'excel' = 'csv'): Promise<Blob> {
    const params = new URLSearchParams();
    
    if (query.userId) params.append('userId', query.userId);
    if (query.action) params.append('action', query.action);
    if (query.entityType) params.append('entityType', query.entityType);
    if (query.entityId) params.append('entityId', query.entityId);
    if (query.startDate) params.append('startDate', query.startDate);
    if (query.endDate) params.append('endDate', query.endDate);
    if (query.limit) params.append('limit', query.limit.toString());
    params.append('format', format);

    const response = await apiService.get(`/api/audit/logs/export?${params.toString()}`, {
      responseType: 'blob',
    });
    return response.data;
  },
};
